import React, { FC, useState } from 'react';
import { Box, Button, Link, TextField, Typography } from '@mui/material';
import { palette } from '../../../theme';

export interface DobStepProps {
  birthday: string;
  onBirthdayChange: (v: string) => void;
  onContinue: () => void;
}

const DobStep: FC<DobStepProps> = ({ birthday, onBirthdayChange, onContinue }) => {
  const [error, setError] = useState('');

  const handleContinue = () => {
    if (!birthday) {
      setError('Please enter your date of birth to continue.');
      return;
    }
    setError('');
    onContinue();
  };

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} mb={0.5}>
        Let&apos;s get started!
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={4}>
        Create your account to begin.
      </Typography>

      <TextField
        label="Date of Birth"
        type="date"
        value={birthday}
        onChange={(e) => {
          setError('');
          onBirthdayChange(e.target.value);
        }}
        fullWidth
        size="small"
        required
        InputLabelProps={{ shrink: true }}
        error={!!error}
        helperText={error}
        sx={{
          mb: 3,
          '& label': { color: palette.primary.main, fontWeight: 600, fontSize: 13 },
          '& label.Mui-focused': { color: palette.primary.main },
          '& .MuiOutlinedInput-root': { borderRadius: '8px' },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: palette.primary.main,
          },
        }}
      />

      <Button
        variant="contained"
        fullWidth
        onClick={handleContinue}
        sx={{
          borderRadius: 999,
          py: 1.25,
          fontWeight: 600,
          fontSize: 15,
          mb: 2,
        }}
      >
        Continue
      </Button>

      <Typography variant="body2" align="center" color="text.secondary">
        Already have an account?{' '}
        <Link href="/login" sx={{ color: palette.primary.main, fontWeight: 700 }}>
          Sign In
        </Link>
      </Typography>
    </Box>
  );
};

export default DobStep;
